import axios from "axios";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const useUpdateCampaign = ({
  getAllCampaigns = () => {},
  onCloseModal = () => {},
}) => {
  const navigate = useNavigate();
  const [isCampaignUpdating, setIsCampaignUpdating] = useState(false);

  const onUpdateCampaign = async (id, payload) => {
    setIsCampaignUpdating(true);
    const token = localStorage.getItem("authToken");

    try {
      const headers = {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "hgs",
      };

      // Only set Content-Type if not FormData (axios will set it automatically for FormData)
      if (!(payload instanceof FormData)) {
        headers["Content-Type"] = "application/json";
      }

      await axios.put(
        `/api/v1/phr-app/marketing-assets/${id}`,
        payload,
        { headers }
      );
      toast.success("Campaign updated successfully !");
      getAllCampaigns();
      setTimeout(() => {
        onCloseModal();
      }, 1000);
    } catch (error) {
      console.error(error, "error");
      const errorMessage = error.response?.data?.message;
      if (!error.response) {
        toast.error("Oops, something went wrong");
      } else {
        const messageContent = Array.isArray(errorMessage) ? (
          <ul className="ms-2 list-disc">
            {errorMessage.map((msg, index) => (
              <li key={index}>{msg}</li>
            ))}
          </ul>
        ) : (
          errorMessage || "An unknown error occurred"
        );
        toast.error(messageContent);
        if (error.response?.data?.statusCode === 401) {
          localStorage.removeItem("authToken");
          setTimeout(() => {
            navigate("/");
          }, 1000);
        }
      }
    } finally {
      setIsCampaignUpdating(false);
    }
  };

  return {
    onUpdateCampaign,
    isCampaignUpdating,
  };
};

export default useUpdateCampaign;

